import {NgModule} from "@angular/core";
import {HotKeysDirective} from "./directives/hotkeys.directive";
//import {HotKeysProvidersModule} from "./hotkeys.providers.module";
@NgModule({
	declarations: [
		HotKeysDirective,
	],
	exports: [
		HotKeysDirective,
	],
	imports: [
		//HotKeysProvidersModule
	]
	})
export class HotkeysModule {
}
